import fileDownload from 'js-file-download';

const BASE_URL = process.env.NODE_ENV !== 'production'
  ? 'http://localhost:3001'
  : 'https://sideop-file-server.daesaingenieria.com';

export default {
  methods: {
    async mixDescargarArchivo(data, origen) {
      this.mostrarDescargando = true;
      await this.axios.get(
        `${BASE_URL}/${data.publicKey}`,
        {
          responseType: 'blob',
          onDownloadProgress: (progressEvent) => {
            if (progressEvent.lengthComputable) {
              this.progresoDescarga = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              );
            }
          },
        },
      )
        .then((res) => {
          if (origen === 'expedientes') {
            fileDownload(res.data,
              `${data.etapa}_${data.documento.orden}_${data.contrato.numero}_${data.documento.descripcion}${data.referencia ? '_'
                : ''}${data.referencia ? data.referencia : ''}.pdf`);
          }
          if (origen === 'documentosRelacionados') {
            fileDownload(res.data, `${data.descripcion}.${data.extension}`);
          }
          if (origen === 'solicitudesPagos') {
            fileDownload(res.data, `${data.nombre}.${data.extension}`);
          }
        })
        .catch((err) => {
          this.mixMensajeError(err.data.message);
        });
      this.mostrarDescargando = false;

      this.progresoDescarga = null;
    },

    async mixGetPdf(data) {
      if (data.publicKey) {
        await this.axios.get(
          `${BASE_URL}/${data.publicKey}`,
          {
            responseType: 'blob',
            onDownloadProgress: (progressEvent) => {
              if (progressEvent.lengthComputable) {
                this.progresoDescarga = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total,
                );
              }
            },
          },
        )
          .then((res) => {
            this.archivoDescarga = res.data;
            this.rutaArchivo = URL.createObjectURL(new Blob([res.data], {
              type: 'application/pdf',
            }));
          })
          .catch((err) => {
            this.mixMensajeError(err.data.message);
          });
      }
    },

    async mixExportarDocumentosPdf(tituloDocumento) {
      this.mostrarDescargando = true;
      await this.axios({
        method: 'POST',
        url: `${BASE_URL}/generarZip`,
        responseType: 'blob',
        data: {
          nombreDocumento: tituloDocumento,
          keys: this.getSoloPublicKeys,
        },
        onDownloadProgress: (progressEvent) => {
          if (progressEvent.lengthComputable) {
            this.progresoDescarga = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total,
            );
          }
        },
      })
        .then((res) => {
          fileDownload(res.data, `${tituloDocumento}.zip`);
        })
        .catch((err) => {
          this.mixMensajeError(err.data.message);
        });
      this.mostrarDescargando = false;
      this.progresoDescarga = null;
    },
  },
};
